// =====================================
//	email 檢查確認
//	@author: Alan
//	@time 2016 / 07 / 04
// =====================================

window.InifECApp.directive('noEmailNotification', ['$rootScope', '$ngModal', '$state', function ($rootScope, $ngModal, $state) {

	var _dir = {};

	var controller = ['$scope', function($scope) {

        // ===============================
        //  開啟 modal
        // ===============================
        var openModal = function() {
        	$ngModal.openModal('no-email-notification');
        }

        // ===============================
        //  關閉 modal
        // ===============================
        var closeModal = function() {
        	$ngModal.closeModal('no-email-notification');
        }

        var gotoProfile = function() {
            $state.go(window.STATES.MEMBER_PROFILE);
            closeModal();
        }

        var init = function() {        

        }

        /*==========================
            Events
        ==========================*/            
        $scope.$on('NO_EMAIL_NOTIFICATION', function(event, data) {
            openModal();
        })

        /*==========================
            Members
        ==========================*/

        /*==========================
            Methods
        ==========================*/
        $scope.gotoProfile = gotoProfile;
        
        /*==========================
            init
        ==========================*/
        init();
        
	}]

	_dir.restrict = "E";
	_dir.scope = true;
	_dir.templateUrl = "partials/modal/no_email_notification.html";
	_dir.controller = controller;

	return _dir;
}]);